import {useMemo, Outlet, Link, FC} from 'external/react'

import {withContext} from 'context/index'
import useAuth from 'context/auth-context/hook'

import IconProfile from 'components/IconProfile'
import ShoppingCart from 'components/ShoppingCart'

import LoginModal from './Login'
import LoginButton from './Buttons/Login'
import ContinueButton from './Buttons/Continue'
import CancelButton from './Buttons/Cancel'
import AdminMenu from '../Menus/AdminMenu'
import ParentMenu from '../Menus/ParentMenu'
import AccountingMenu from 'layout/Menus/AccountingMenu'

const PublicLayout: FC = () => {

	const {role} = useAuth()

	const Menu = useMemo(() => {
		switch (role) {
			case 'ADMIN_HOMESCHOOLER': return AdminMenu
			case 'PARENT': return ParentMenu
			case 'ACCOUNTING': return AccountingMenu
			default: return undefined
		}
	}, [role])

	return (
		<>
			<div className='navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top'>
			<span className='navbar-brand'>
				<Link to={'/offers'} className='navbar-brand fw-bold' style={{ color: '#42C3DB' }} >
					EduSystem
				</Link>
			</span>
			<div className='navbar-collapse principal-menu' style={{justifyContent: 'flex-end'}} id='navbar-collapse'>
					<ul className='nav navbar-nav ml-auto'>
						{Menu && <Menu />}
						<CancelButton />
						<ContinueButton />
						<LoginButton />
						<LoginModal />
						<ShoppingCart className='nav-item me-4 mt-2' />
						{role && <IconProfile />}
					</ul>
				</div>
			</div>
			<Outlet />
		</>
	)
}

export default withContext(PublicLayout, 'public')